<form edlFocusTrap [formGroup]="form" novalidate errorTailor>
    <div class="modal-body">
        <div class="content" *ngIf="busy">
            <div class="loader"></div>
        </div>

        <div class="col-sm-12">
            <div class="card-title">
                <div class="d-flex align-items-center gap-2 mb-2">
                    <div class="flex-details-header-container">
                        <h4 class="card-title mb-0">
                            <timetracking-status-indicator [statusId]="0" [a48ContextCode]="null"
                                [timeTrackingType]="TimeTrackingType.FLEX" ngbTooltip="Flex Hours Status"
                                placement="bottom"></timetracking-status-indicator>
                            {{ userName }} - Flex Hours Configuration
                        </h4>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <small class="text-muted">
                            <strong>Request Item:</strong> {{ itemTitle }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row" *ngIf="!busy">
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="flexHours" class="form-label">Hours<span class="required">*</span> </label>
                    <input type="number" id="flexHours" min="0" step="0.5" class="form-control" formControlName="Hours">
                </div>
            </div>

            <div class="col-sm-12">
                <div class="form-group">
                    <label for="flexEventName" class="form-label">Event Name<span class="required">*</span></label>
                    <input type="text" id="flexEventName" class="form-control" formControlName="EventName">
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="form-label">Event Start<span class="required">*</span></label>
                    <edl-date-picker formControlName="EventStartDate"></edl-date-picker>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="form-label">Event End<span class="required">*</span></label>
                    <edl-date-picker formControlName="EventEndDate"></edl-date-picker>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" [class.flex-btn-busy]="busy" [disabled]="!canSave() || busy"
            [attr.aria-disabled]="busy ? 'true' : null" (click)="onSave()">
            <i *ngIf="busy" class="fas fa-spinner fa-spin me-2" aria-label="Loading"></i>
            <span *ngIf="!busy">Save</span>
        </button>
        <div aria-live="polite" class="visually-hidden">
            <span *ngIf="busy">Saving, please wait...</span>
        </div>
    </div>
</form>